// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__NO6Eo","checkboxCol":"Table_checkboxCol__omdNy","emailCol":"Table_emailCol__3ytIA","actionCol":"Table_actionCol__2cyJL"};